module.exports = __webpack_public_path__ + "img/a.3630fd78.jpg";